import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { cloudnativePageMeta, cloudnativeSchema } from 'components/common/schema'
import Template from 'components/services/cloudnative'

const CloudNative: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...cloudnativePageMeta} />
      <JsonLd data={cloudnativeSchema} />
      <Template />
    </>
  )
}

export default CloudNative
